import { render, staticRenderFns } from "./WithdrawModal.vue?vue&type=template&id=c5d8d07c"
import script from "./WithdrawModal.vue?vue&type=script&lang=ts"
export * from "./WithdrawModal.vue?vue&type=script&lang=ts"
import style0 from "./WithdrawModal.vue?vue&type=style&index=0&id=c5d8d07c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports